var stripData = [
    {
        'title': '1.你喜欢不喜欢这段讲解视频\uFF1F',
        'likeChoose': [
            {
                id: 1,
                text: '喜欢',
                code: 1,
                curStatus: false,
                text_id: 'VIDEO_LIKE'
            },
            {
                id: 2,
                text: '不喜欢',
                code: 2,
                curStatus: false,
                text_id: 'VIDEO_NO_LIKE'
            }
        ]
    },
    {
        'title': '2.看完这段视频讲解你学会了吗\uFF1F',
        'likeChoose': [
            {
                id: 1,
                text: '学会了',
                code: 3,
                curStatus: false,
                text_id: 'LEARNED'
            },
            {
                id: 2,
                text: '没学会',
                code: 4,
                curStatus: false,
                text_id: 'NOT_LEARNED'
            }
        ]
    }
];
var multStripData = [{
        'title': '3.没学会的原因\uFF1F\uFF08可多选\uFF09',
        'likeChoose': [
            {
                id: 1,
                text: '视频不清晰',
                code: 5,
                curStatus: false,
                text_id: 'VIDEO_NOT_CLEAR'
            },
            {
                id: 2,
                text: '视频有杂音',
                code: 6,
                curStatus: false,
                text_id: 'AUDIO_NOT_CLEAR'
            },
            {
                id: 3,
                text: '讲解语速过快',
                code: 7,
                curStatus: false,
                text_id: 'SPEED_FAST'
            },
            {
                id: 4,
                text: '思路跟不上',
                code: 8,
                curStatus: false,
                text_id: 'THINK_NO_SYNCHRO'
            },
            {
                id: 5,
                text: '和学校讲的不同',
                code: 9,
                curStatus: false,
                text_id: 'UNLIKE_SCHOOL'
            },
            {
                id: 6,
                text: '涉及未学过知识点',
                code: 10,
                curStatus: false,
                text_id: 'NO_LEARN'
            },
            {
                id: 7,
                text: '概念不理解',
                code: 11,
                curStatus: false,
                text_id: 'CONCEPT_NO_UNDERSTAND'
            },
            {
                id: 8,
                text: '视频讲解不详细',
                code: 12,
                curStatus: false,
                text_id: 'CONTENT_CRUDE'
            }
        ]
    }];
export {
    stripData,
    multStripData
};